// extracted by mini-css-extract-plugin
export default {"menuArea":"Menu_menuArea__9R920","topBg":"Menu_topBg__zw6qg","menuItem":"Menu_menuItem__Ewdtl"};